'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$0024anon$00246 from "./presto.-Fetcher$$anon$6.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024 from "./presto.-Fetcher$-Unified-Error-Format$.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$5() {
  this.aUc = null;
  this.aU4 = null;
  this.aU5 = false;
  this.aUd = null;
  this.aUe = false;
  this.aUh = null;
  this.aUa = null;
  this.aUb = false;
  this.aU6 = null;
  this.aU7 = false;
  this.aU8 = null;
  this.aU9 = false;
  this.aUf = false;
  this.aUg = false;
  this.aUc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aUh = "UnifiedErrorFormat";
}
export { $c_Lpresto_Fetcher$$anon$5 as $c_Lpresto_Fetcher$$anon$5 };
$p = $c_Lpresto_Fetcher$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$$anon$5;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$5() {
}
export { $h_Lpresto_Fetcher$$anon$5 as $h_Lpresto_Fetcher$$anon$5 };
$h_Lpresto_Fetcher$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aUc;
});
$p.M = (function() {
  if ((!this.aU5)) {
    this.aU4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aU5 = true;
  }
  return this.aU4;
});
$p.O = (function() {
  if ((!this.aUe)) {
    this.aUd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aUe = true;
  }
  return this.aUd;
});
$p.E = (function() {
  return this.aUh;
});
$p.t = (function() {
  if ((!this.aUb)) {
    this.aUa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("status", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("trace", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aUb = true;
  }
  return this.aUa;
});
$p.N = (function() {
  if ((!this.aU7)) {
    this.aU6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aU7 = true;
  }
  return this.aU6;
});
$p.Q = (function() {
  if ((!this.aU9)) {
    this.aU8 = new $j_presto$002e$002dFetcher$0024$0024anon$00246.$c_Lpresto_Fetcher$$anon$6();
    this.aU9 = true;
  }
  return this.aU8;
});
$p.v = (function() {
  if ((!this.aUg)) {
    this.aUf = false;
    this.aUg = true;
  }
  return this.aUf;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee19) => ((p) => \u03b4scrutinee19.cFw(p)))($j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024.$m_Lpresto_Fetcher$UnifiedErrorFormat$())));
});
var $d_Lpresto_Fetcher$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$5, "presto.Fetcher$$anon$5", ({
  J0: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Fetcher$$anon$5 as $d_Lpresto_Fetcher$$anon$5 };
//# sourceMappingURL=presto.-Fetcher$$anon$5.js.map
